const labels = {
  acceptUser: 'Accetta utente',
  accepted: 'Accettato',
  add: 'Aggiungi',
  address: 'Indirizzo',
  all: 'Tutti',
  allUsers: 'Tutti gli utenti',
  amount: 'Importo',
  annotations: 'Annotazioni',
  approved: 'Approvato',
  assignedAt: 'Assegnato il',
  assignedBy: 'Assegnato da',
  attachedFiles: 'File allegati',
  back: 'Indietro',
  balance: 'Bilancio',
  buy: 'Compra',
  cancel: 'Annulla',
  capturedOn: 'Rilevato il',
  citizenship: 'Cittadinanza',
  city: 'Città',
  close: 'Chiudi',
  closed: 'Chiuso',
  code: 'Codice',
  completed: 'Completato',
  confirm: 'Conferma',
  confirmRequest: 'Conferma richiesta',
  congratulations: 'Congratulazioni',
  counterpart: 'Controparte',
  country: 'Paese',
  customerData: 'Dati cliente',
  dashboard: 'Dashboard',
  date: 'Data',
  dateOfBirth: 'Data di nascita',
  detail: 'Dettaglio',
  document: 'Documento',
  done: 'Done',
  download: 'Scarica',
  dropDocument: 'Rilascia documento',
  edit: 'Modifica',
  effect: 'Effetto',
  email: 'Email',
  externalReference: 'Riferimento esterno',
  evaluated: 'Valutato',
  file: 'File',
  files: 'Files',
  from: 'Da',
  gender: 'Genere',
  handling: 'In gestione',
  hash: 'Hash',
  high: 'Alto',
  info: 'Info',
  inviteUser: 'Invita utente',
  involvment: 'Coinvolgimento',
  issue: 'Emetti',
  kybVerify: 'Verifica KYB',
  kycVerify: 'Verifica KYC',
  level: 'Livello',
  low: 'Basso',
  manage: 'Gestisci',
  medium: 'Medio',
  message: 'Messaggio',
  metadata: 'Metadati',
  more: 'Altro',
  name: 'Nome',
  new: 'Nuovo',
  next: 'Successivo',
  no: 'No',
  note: 'Nota',
  paymentMethod: 'Metodo di pagamento',
  pending: 'In attesa',
  placeOfBirth: 'Luogo di nascita',
  purchase: 'Acquista',
  quantity: 'Quantità',
  recipient: 'Destinatario',
  rejectUser: 'Rifiuta utente',
  rejected: 'Rifiutato',
  reviewDecision: 'Rivedi decisione',
  save: 'Salva',
  search: 'Cerca',
  searchByFirstOrLastName: 'Cerca per nome o cognome',
  searchByTypeOrFullName: 'Cerca per tipo (INDIVIDUAL/COMPANY) o nome completo',
  searchByLastNameWalletStateKeyOrSarId:
    'Cerca per cognome, wallet, stato (done, todo, ...) o ID SAR',
  searchByNameEmailOrRole: 'Cerca per nome, cognome o email',
  searchByWallet: 'Cerca per wallet',
  searchByWalletOrName: 'Cerca per wallet o nome',
  select: 'Seleziona',
  selectWallet: 'Seleziona wallet',
  sell: 'Vendi',
  sender: 'Mittente',
  severe: 'Grave',
  signOut: 'Esci',
  specify: 'Specifica',
  status: 'Stato',
  summary: 'Sommario',
  supportingDocumentation: 'Documentazione di supporto',
  surname: 'Cognome',
  taxId: 'Codice fiscale',
  to: 'A',
  today: 'Oggi',
  todo: 'Todo',
  token: 'Token',
  transaction: 'Transazione',
  tryAgain: 'Riprova',
  type: 'Tipo',
  unassigned: 'Non assegnato',
  update: 'Aggiorna',
  user: 'Utente',
  userRegistry: 'Registro utenti',
  verifiedBy: 'Verificato da',
  verified: 'Verificato',
  verify: 'Verifica',
  verifyDate: 'Data verifica',
  video: 'Video',
  view: 'Vedi',
  wallet: 'Wallet',
  wallets: 'Wallets',
  yes: 'Sì',
};

export default labels;
